import { configureStore } from "@reduxjs/toolkit";
import queueReducer from "./dataSlices/queueSlice"

export const store = configureStore({
    reducer: {
        queue: queueReducer
    },
})